/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, TextField, Button } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Dropdown, Menu, Modal } from "antd";
import moment from 'moment';
import { supplierPaymentBillHead } from "../../../../../config/constant";
import { capitalizeFirstLetter, currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';


export const SupplierPaymentsTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreContent, search, loadMoreTask, roleManagement } = props;
    const { editLoader, editDetails, editError, createDetails, createError } = useSelector(state => state.crudReducer);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reason, setReason] = useState('');
    const [paymentId, setPaymentId] = useState('');
    const [name, setName] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [errorReason, setErrorReason] = useState(false);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const dispatch = useDispatch();
    const onDelete = (data) => {
        setDeleteModal(true);
        setPaymentId(data.id);
        setName(data?.serialNo);
    }

    const handleCancel = () => {
        setIsModalVisible(false);
        setReason('');
        setErrorReason(false);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }
    const handlePaymentCancel = (data) => {
        setPaymentId(data.id);
        setIsModalVisible(true);
    }

    const deletePayment = (e) => {
        e.preventDefault();

        let emptyReason = emptyValidation('Reason', reason);
        if (emptyReason.isValid) {
            changeStatus(paymentId, 'CANCELLED', reason);
        } else {
            if (emptyReason.errors) {
                setErrorReason(emptyReason.errors);
            }
        }
    }

    const changeStatus = (id, status, reason = '') => {
        let details = {
            paymentStatus: status
        };

        if (reason !== '') {
            details["reversalReason"] = reason;
        }

        let data = {
            type: status === 'CONFIRMED' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
            url: status === 'CONFIRMED' ? `/supplierPayment/${id}/confirmPayment` : 'supplierPayment',
            title: 'Supplier Payment',
            id: id,
            details: details
        }

        if (status === 'CANCELLED') {
            data['slug'] = "cancel";
        }

        dispatch(data);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            // toast(editDetails);
            loadTasks();
            setIsModalVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(editDetails);
            loadTasks();
            setReason('');
            setIsModalVisible(false);
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={supplierPaymentBillHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={supplierPaymentBillHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'view', 'Purchase') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'supplierPayment', 'Link')} style={{ width: getColumnWidth(supplierPaymentBillHead, 0) }} to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.bold)}>{data.serialNo}</Link> : <span style={{ width: getColumnWidth(supplierPaymentBillHead, 0) }}>{data.serialNo}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 1) }}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 1) }}>{data.supplier ? data.supplier.name : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 2) }}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 2) }}>{data?.supplier?.serialNo ? data?.supplier?.serialNo : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 3) }}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 3) }}>{moment(data.date).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 4) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 4) }}>{'₹  '}{currencyFormat(data.paymentAmount)}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 5) }}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 5) }}>{data.mop ? data.mop.method : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierPaymentBillHead, 6) }}><span style={{ width: getColumnWidth(supplierPaymentBillHead, 6) }}><span style={{ display: "inline-block" }} className={clsx(classes.statusButton, { [classes.confirmedButton]: data.paymentStatus === 'CONFIRMED' }, { [classes.reversedButton]: data.paymentStatus === 'CANCELLED' })}>{capitalizeFirstLetter(data.paymentStatus)}</span></span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'view', 'Purchase') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'supplierPayment', 'Icon')} to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(data.id)}/view`}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}

                                                                />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'edit', 'Purchase') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'supplierPayment', 'Icon')} to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(data.id)}/edit`} className={clsx({ [classes.disabled]: data.paymentStatus === 'CONFIRMED' || data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED' })}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Payment', 'deletable', 'Purchase') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'supplierPayment', 'Icon')} to={"#"} className={clsx({ [classes.disabled]: data.paymentStatus === 'CONFIRMED' || data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED' })} onClick={() => onDelete(data)}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Ellipsis Action', 'Cancel') && !data?.supplierPaymentItems &&
                                                                        data.paymentStatus === 'CONFIRMED' && <Menu.Item key="confirmed"><NavLink to={'#'} onClick={() => handlePaymentCancel(data)} id={idNamingConversion('Cancel_' + data.id, 'supplierPayment', 'Icon')}>Cancel</NavLink></Menu.Item>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Ellipsis Action', 'View') &&
                                                                        (data.paymentStatus === 'CANCELLED' || data.paymentStatus === 'REVERSED') && <Menu.Item key="cancel"><NavLink to={`/purchase/purchase-management/supplier-payment/${AESEncrypt(data.id)}/view`} id={idNamingConversion('View_' + data.id, 'supplierPayment', 'Icon')}>View</NavLink></Menu.Item>
                                                                    }
                                                                    {
                                                                        !data.supplier.isHold && <>
                                                                            {
                                                                                roleManagement !== '' && checkComponentPermission('Supplier Payment', 'Ellipsis Action', 'Confirm') &&
                                                                                data.paymentStatus === 'CREATED' && <Menu.Item key="created"><NavLink to={'#'} onClick={() => changeStatus(data.id, 'CONFIRMED')} id={idNamingConversion('Confirm_' + data.id, 'supplierPayment', 'Icon')}>Confirm</NavLink></Menu.Item>
                                                                            }
                                                                        </>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'supplierPayment', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={supplierPaymentBillHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>All Supplier Payments will be listed here when transactions are recorded by the system</p>

                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <Modal
                title={'Reason for Cancellation'}
                open={isModalVisible}
                onOk={() => handleCancel()}
                onCancel={() => handleCancel()}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                // closeIcon={<CloseIcon />}
                footer={[
                    <Button
                        key="Confirm"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                        onClick={(e) => deletePayment(e)}
                    >Confirm</Button>,
                ]}>
                <TextField autoComplete='one-time-code'
                    label='Enter the reason for Cancellation'
                    fullWidth
                    variant={'standard'}
                    error={errorReason && true}
                    helperText={errorReason}
                    InputProps={{
                        classes: {
                            input: classes.textFieldColor,
                        }
                    }}
                    InputLabelProps={{
                        className: classes.textFieldLableColorCustom
                    }}
                    onChange={(e) => setReason(e.target.value)}
                />
            </Modal>
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={paymentId} loadTasks={() => loadTasks()} name={name} url={'supplierPayment'} title={'Supplier Payment'} visible={deleteModal} />
        </>
    )
}